import React, { useState } from 'react';
import { ImageOff } from 'lucide-react';

/**
 * Renders an <img> that gracefully degrades to a placeholder when the URL
 * 404s or fails to decode — instead of showing the browser's broken-image
 * icon. Used by the property gallery + carousel so a single bad image in a
 * 15-photo set doesn't make the whole grid look broken.
 */
const SafeImage = ({ src, alt, className = '', placeholderClassName = '', ...rest }) => {
  const [failed, setFailed] = useState(false);

  if (failed || !src) {
    return (
      <div
        className={`flex flex-col items-center justify-center bg-gray-100 text-gray-400 ${className} ${placeholderClassName}`}
        role="img"
        aria-label={alt || 'Image unavailable'}
        data-testid="safe-image-fallback"
      >
        <ImageOff className="w-8 h-8 mb-2" />
        <span className="text-xs px-3 text-center">Image unavailable</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
      {...rest}
    />
  );
};

export default SafeImage;
